module.exports = __webpack_public_path__ + "static/media/33.42836663.png";